import { sdkClient } from "./sdk";
import { KastWebSdkClient } from '@kalyzee/kast-web-sdk';

export interface WindowDebugData {
  enabled: boolean;
  sdkClient: KastWebSdkClient;
  [key: string]: any;
}

export class Debug {
  static init(enable: boolean): WindowDebugData {
    const currWindow = window as any;
    if (!currWindow.__DEBUG__) {
      const data: WindowDebugData = {
        enabled: enable,
        sdkClient: sdkClient,
      };
      currWindow.__DEBUG__ = data;
    }
    return currWindow.__DEBUG__;
  }

  static getData(): WindowDebugData | undefined {
    const currWindow = window as any;
    const data: WindowDebugData | undefined = currWindow.__DEBUG__;
    return data;
  }

  static isEnabled(): boolean {
    const data = this.getData();
    return data?.enabled === true;
  }

  static enable(): void {
    const data = this.getData();
    if (!data) return;
    data.enabled = true;
  }

  static disable(): void {
    const data = this.getData();
    if (!data) return;
    data.enabled = false;
  }
}
